// extracted by mini-css-extract-plugin
export var success = "success-module--success--3lZ3t";
export var title = "success-module--title--KoHNX";
export var subtitle = "success-module--subtitle--2EZzd";
export var lottie = "success-module--lottie--3ZyFQ";